import styled from "styled-components";
import FormHelperText from "@mui/material/FormControl";

export const HelperText = styled(FormHelperText)`
  font-size: 0.75rem;
  line-height: 1.66;
  color: ${({ theme }) => theme.palette.error.main};
`;
